export default __webpack_public_path__ + "static/media/WeShoot-logo-extended-black.ec37e4ec.svg";